import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import logo from "../assets/logo.webp";

const Footer = () => {
  return (
    <footer className="bg-[#021622] text-white py-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 text-center md:text-left">
        {/* Logo + Address */}
        <div className="space-y-4">
          <div className="mx-auto md:mx-0 inline-flex rounded-3xl bg-white/95 p-4 shadow-lg">
            <img src={logo} alt="WVT Elevators" className="h-20 w-auto object-contain" />
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3">OUR ADDRESS</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              A-35, 4th Floor, Street No. 02, Madhu Vihar Rd, Madhu Vihar, <br />
              I.P.Extension, Patparganj, New Delhi, Delhi, 110092
            </p>
          </div>
        </div>

        {/* Opening Hours */}
        <div>
           <h3 className="text-lg font-semibold mb-3">GET IN TOUCH</h3>
          <p className="text-sm text-gray-300 mb-3">
            <span className="font-semibold text-white">Website:</span>
            <br />
            <a href="https://wvtelevators.com" target="_blank" rel="noreferrer" className="text-cyan-200 hover:text-white underline">
              www.wvtelevators.com
            </a>
          </p>
          <p className="text-sm text-gray-300 mb-3">
            <span className="font-semibold text-white">Email:</span>
            <br />
            <a href="mailto:sales@wvtelevators.com" className="text-cyan-200 hover:text-white underline">
              sales@wvtelevators.com
            </a>
          </p>
          <div className="mt-4 flex items-center justify-center md:justify-start gap-4 text-gray-300">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition"
            >
              <FaLinkedinIn />
            </a>
          </div>
          <br></br>
          <h3 className="text-lg font-semibold mb-3">OPENING HOURS</h3>
          <p className="text-sm text-gray-300">Mon - Sat : 9:30 AM - 6:30 PM</p>
          <p className="text-sm text-gray-300">Sunday : Holiday</p>
        </div>

        {/* Contact Actions */}
        <div className="flex flex-col items-center md:items-start">
          <h3 className="text-lg font-semibold mb-3">CONTACT US FOR NEW SALES</h3>
          <div className="flex items-center justify-center md:justify-start space-x-2 mb-4">
            <FaPhoneAlt className="text-cyan-400 text-xl" />
            <span className="text-sm text-gray-300 font-medium">
              9999762470
            </span>
          </div>
          <p className="text-sm text-gray-300 mb-4">
            Contact us for New sales and inquiries regarding our products and sales services.
          </p>
          <p className="text-sm text-gray-300 mb-4">
            Mobile: 9999762470, 9811484679,<br />Landline: 01135013565
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:9999762470"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-cyan-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-700 transition"
            >
              <FaPhoneAlt /> Call
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=919999762470&text=Hello%20WVT%20Elevators"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#1ebe5a] transition"
            >
              <FaWhatsapp /> WhatsApp
            </a>
          </div>
        </div>

        {/* Repair & Maintenance */}
        <div className="flex flex-col items-center md:items-start">
          <h3 className="text-lg font-semibold mb-3">REPAIR & MAINTENANCE</h3>
              <div className="flex items-center justify-center md:justify-start space-x-2 mb-4">
            <FaPhoneAlt className="text-cyan-400 text-xl" />
            <span className="text-sm text-gray-300 font-medium">
              9999762480
            </span>
          </div>
          <p className="text-sm text-gray-300 mb-4">
            Contact us for repairing and maintenance services.
          </p>
          <p className="text-sm text-gray-300 mb-4">
            Mobile: 9999762480, 9811484679<br />Landline: 011-41253738
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:9999762470"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-cyan-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-700 transition"
            >
              <FaPhoneAlt /> Call
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=919999762480&text=Hello%20WVT%20Elevators"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#1ebe5a] transition"
            >
              <FaWhatsapp /> WhatsApp
            </a>
          </div>
        </div>

      </div>

      {/* Bottom line */}
      <div className="text-center text-gray-400 text-xs mt-10 border-t border-white/10 pt-4 space-y-1">
        <p>© {new Date().getFullYear()} WVT Elevators. All Rights Reserved.</p>
        <p>
          Visit <a href="https://wvtelevators.com" target="_blank" rel="noreferrer" className="text-white underline">wvtelevators.com</a> | Email <a href="mailto:sales@wvtelevators.com" className="text-white underline">sales@wvtelevators.com</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
